import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './lib/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingPetals from './components/FloatingPetals';
import ChatWidget from './components/ChatWidget';
import Home from './pages/Home';
import Philosophy from './pages/Philosophy';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Team from './pages/Team';
import TherapistDetail from './pages/TherapistDetail';
import WhyCCCPage from './pages/WhyCCCPage';
import Contact from './pages/Contact';
import Schedule from './pages/Schedule';
import { Blog, BlogPost } from './pages/Blog';
import Insurance from './pages/Insurance';
import ExistingClients from './pages/ExistingClients';
import TraumaIntensives from './pages/TraumaIntensives';
import { Privacy, Terms } from './pages/Legal';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPostEditor from './pages/admin/AdminPostEditor';
import ProtectedRoute from './pages/admin/ProtectedRoute';

function RevealObserver() {
  const location = useLocation();
  useEffect(() => {
    const t = setTimeout(() => {
      const els = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale, .reveal-blur');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
      }, { threshold: 0.1 });
      els.forEach(el => io.observe(el));
    }, 60);
    return () => clearTimeout(t);
  }, [location.pathname]);
  return null;
}

function PageFade({ children }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-fade">
      {children}
    </div>
  );
}

function ChromeShell({ children }) {
  const location = useLocation();
  const hideChrome = location.pathname.startsWith('/admin');
  return (
    <>
      {!hideChrome && <FloatingPetals count={7} opacity={0.35} />}
      {!hideChrome && <Header />}
      <main>{children}</main>
      {!hideChrome && <Footer />}
      {!hideChrome && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <RevealObserver />
            <ChromeShell>
              <PageFade>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/philosophy" element={<Philosophy />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/:slug" element={<ServiceDetail />} />
                  <Route path="/team" element={<Team />} />
                  <Route path="/team/:slug" element={<TherapistDetail />} />
                  <Route path="/why-ccc" element={<WhyCCCPage />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/schedule" element={<Schedule />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/insurance" element={<Insurance />} />
                  <Route path="/trauma-intensives" element={<TraumaIntensives />} />
                  <Route path="/existing-clients" element={<ExistingClients />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />

                  {/* Admin */}
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                  <Route path="/admin/posts/new" element={<ProtectedRoute><AdminPostEditor /></ProtectedRoute>} />
                  <Route path="/admin/posts/:id/edit" element={<ProtectedRoute><AdminPostEditor /></ProtectedRoute>} />
                </Routes>
              </PageFade>
            </ChromeShell>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
